export default __webpack_public_path__ + "static/media/pic6.8ef37e6e.jpg";